const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class DevelopmentOfCrafts extends Event {
    constructor(){
        super(
            Age.AgeA,
            EventNames.DevelopmentOfCrafts,
            "Each Civilization gains 2 resources.",
            {}
        )
    }
}

module.exports = DevelopmentOfCrafts;